import css from '@styled-system/css'
import styled from 'styled-components'
import { ResponsiveValue, variant } from 'styled-system'

import { Icon } from '../images'
import { lgBumps } from '../layout'

export type PromotionalBannerActivateProperty = 'default'

export interface PromotionalBannerActivateProps {
  variant?: ResponsiveValue<PromotionalBannerActivateProperty>
  backgroundImage: undefined | string
}

export const PromotionalBannerActivate = styled.div<PromotionalBannerActivateProps>(
  ({ backgroundImage }) =>
    css({
      color: 'foregroundPromoBanner',
      backgroundColor: 'backgroundPromoBanner',
      backgroundImage: backgroundImage ? `url('${backgroundImage}')` : undefined,
      backgroundSize: 'cover',
      backgroundPosition: '0px 0px',
      borderRadius: 2,
      p: lgBumps,
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      [Icon]: {
        path: {
          fill: 'foregroundPromoBanner',
        },
      },
      position: 'relative',
    }),
  variant({
    scale: 'PromotionalBannerActivate',
    variants: {
      default: {},
    },
  }),
)

PromotionalBannerActivate.defaultProps = {
  variant: 'default',
}
